var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    [
      _c(
        "v-container",
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c("v-select", {
                    attrs: {
                      label:
                        "Sección del Permiso de Acceso que requiere una modificación",
                      items: _vm.commentarySections,
                      rules: [_vm.rules.required()],
                      "item-text": "name",
                      "return-object": ""
                    },
                    model: {
                      value: _vm.sections[0],
                      callback: function($$v) {
                        _vm.$set(_vm.sections, 0, $$v)
                      },
                      expression: "sections[0]"
                    }
                  }),
                  _c("v-textarea", {
                    staticClass: "mt-3",
                    attrs: {
                      outlined: "",
                      counter: "65500",
                      rows: "3",
                      label: "Descripción del cambio a solicitar",
                      rules: [
                        _vm.rules.required(),
                        _vm.rules.fieldLength(65550),
                        _vm.rules.specialCharacters()
                      ]
                    },
                    model: {
                      value: _vm.comment[0],
                      callback: function($$v) {
                        _vm.$set(_vm.comment, 0, $$v)
                      },
                      expression: "comment[0]"
                    }
                  }),
                  _vm.IS_EMPLOYEE && _vm.workflowSteps.length > 0
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "ma-2",
                          attrs: { color: "#2B953E", outlined: "" },
                          on: { click: _vm.sendRequestForChange }
                        },
                        [_vm._v("ENVIAR CAMBIOS ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }